// Shared status badge styling for the admin dashboard.
//
// Bulk/manual orders persist lowercase status strings ('delivered',
// 'completed'), customer-facing orders use TitleCase ('Pending Payment',
// 'Paid'), and custom-scent / tester-kit orders use a mix. The helpers
// here normalise both the colour lookup and the display label so every
// status badge in the admin UI feels consistent regardless of source.

const STATUS_COLORS = {
  'pending': 'bg-yellow-500/20 text-yellow-400',
  'pending payment': 'bg-yellow-500/20 text-yellow-400',
  'pending payment review': 'bg-yellow-500/20 text-yellow-400',
  'paid_pending_approval': 'bg-amber-500/20 text-amber-400',
  'paid': 'bg-blue-500/20 text-blue-400',
  'approved': 'bg-blue-500/20 text-blue-400',
  'preparing': 'bg-purple-500/20 text-purple-400',
  'processing': 'bg-purple-500/20 text-purple-400',
  'in_progress': 'bg-blue-500/20 text-blue-400',
  'in progress': 'bg-blue-500/20 text-blue-400',
  'shipped': 'bg-cyan-500/20 text-cyan-400',
  'in_transit': 'bg-cyan-500/20 text-cyan-400',
  'delivered': 'bg-green-500/20 text-green-400',
  'completed': 'bg-green-500/20 text-green-400',
  'fulfilled': 'bg-green-500/20 text-green-400',
  'rejected': 'bg-red-500/20 text-red-400',
  'cancelled': 'bg-red-500/20 text-red-400',
  'refunded': 'bg-orange-500/20 text-orange-400',
};

export function getOrderStatusColor(status) {
  if (!status) return 'bg-white/10 text-white';
  return STATUS_COLORS[String(status).toLowerCase().trim()] || 'bg-white/10 text-white';
}

export function formatOrderStatusLabel(status) {
  if (!status) return '';
  return String(status)
    .replace(/_/g, ' ')
    .split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
